// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CodeGraphNodeCategorySchema = z.enum(['CLIENT','ROUTING','CONFIGURATION','MIDDLEWARE','LOGIC','UTILITY','EVENT','DATABASE'] as const);

export type CodeGraphNodeCategoryType = `${z.infer<typeof CodeGraphNodeCategorySchema>}`

export default CodeGraphNodeCategorySchema;
